import { render, staticRenderFns } from "./lang-switcher.vue?vue&type=template&id=7913850a&"
import script from "./lang-switcher.vue?vue&type=script&lang=js&"
export * from "./lang-switcher.vue?vue&type=script&lang=js&"
import style0 from "./lang-switcher.vue?vue&type=style&index=0&id=7913850a&prod&lang=scss&"
import style1 from "./lang-switcher.vue?vue&type=style&index=1&id=7913850a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzLangSwitcher: require('/opt/airport.kg/node_modules/razlet-ui/src/components/lang-switcher/index.vue').default})
